














































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { mixins } from "vue-class-component";
import QueryEndpointData from "./dataquery-mixin";

import MetricsHistogram from "./MetricsHistogram.vue";

@Component({
    components: {
        MetricsHistogram,
    },
})
export default class Metrics extends mixins(QueryEndpointData) {
    @Prop() metric_type?:
        | "supply_chain_leg_cat"
        | "total"
        | "hist_supply_chain"
        | "hist_total"
        | null;
    @Prop() map_id!: string;
    @Prop() histogram!: boolean;

    selectedMetricTitle: any = null;

    metrics = {
        distance_metric: {
            value: "od_km",
            unit: "(km)",
            title: {
                total: "Total Trip Distance",
                supply_chain_leg_cat: "Avg Trip Distance",
            },
            description: {
                total: "The sum of trip distances (km), weighted by movement tonnes, travelled by the commodity from its point of production or import to point of retail or export.",
                supply_chain_leg_cat:
                    "The average of the trip distance (km), weighted by movement tonnes, travelled for each movement in the supply chain leg category.",
            },
        },
        duration_metric: {
            value: "od_hour",
            unit: "(hrs)",
            title: {
                total: "Total Trip Duration",
                supply_chain_leg_cat: "Avg Trip Duration",
            },
            description: {
                total: "The sum of trip durations (hrs), weighted by movement tonnes, taken for the transportation of a commodity from its point of production or import to its point of retail or export.",
                supply_chain_leg_cat:
                    "The average of the trip duration (hrs), weighted by movement tonnes, taken for each movement in the supply chain leg category.",
            },
        },
        cost_metric: {
            value: "cost_per_tonne",
            unit: "($)",
            title: {
                total: "Total Transport Costs/tn",
                supply_chain_leg_cat: "Avg Transport Costs/tn",
            },
            description: {
                total: "The sum of trip costs ($) per tonne of freight, weighted by movement tonnes, for the transportation of a commodity from its point of production or import to its point of retail or export.",
                supply_chain_leg_cat:
                    "The average of the trip costs ($) per tonne of freight, weighted by movement tonnes, for each movement in the supply chain leg category.",
            },
        },
        co2_metric: {
            value: "co2_per_tonne",
            unit: "(kg)",
            title: {
                total: "Total CO<sub>2</sub> Emissions/tn",
                supply_chain_leg_cat: "Avg CO<sub>2</sub> Emissions/tn",
            },
            description: {
                total: "The sum of trip CO2 (kg) per tonne of freight, weighted by movement tonnes, produced in the transportation of a commodity from its point of production or import to its point of retail or export.",
                supply_chain_leg_cat:
                    "The average of the trip CO2 (kg) per tonne of freight, weighted by movement tonnes, for each movement in the supply chain leg category.",
            },
        },
        crossings_metric: {
            value: "state_territory_border_crossings",
            unit: "",
            title: {
                total: "Total State or Territory Border Crossings",
            },
            description: {
                total: "The sum of the number of trip State/Territory Border Crossings, weighted by movement tonnes, involved in the transportation of a commodity from its point of production or import to its point of retail or export.",
            },
        },
    } as const;

    get metricsUrl() {
        return (
            process.env.VUE_APP_BACKEND_BASE + "/supplychainexplorer/metrics"
        );
    }

    mounted() {
        this.loadData(this.metricsUrl);
    }

    @Watch("updateRequired")
    reloadData(newVal: any, oldVal: any) {
        this.loadData(this.metricsUrl);
    }

    metric_values(metric: string) {
        return this.data.find(
            (d: any) =>
                d.metric === metric &&
                (!d.supply_chain_leg_cat ||
                    d.supply_chain_leg_cat === this.map_id),
        );
    }

    get trip_distance() {
        var entry = this.metric_values(this.metrics.distance_metric.value);
        return this.numberWithCommas(
            (entry?.value as number)?.toFixed(1) || "0",
        );
    }

    get trip_duration() {
        var entry = this.metric_values(this.metrics.duration_metric.value);
        return this.numberWithCommas(entry?.value?.toFixed(1) || "0");
    }

    get transport_costs() {
        var entry = this.metric_values(this.metrics.cost_metric.value);
        return this.numberWithCommas(entry?.value?.toFixed(1) || "0");
    }

    get co2_kg() {
        var entry = this.metric_values(this.metrics.co2_metric.value);
        return this.numberWithCommas(entry?.value?.toFixed(0) || "0");
    }

    get border_crossings() {
        var entry = this.metric_values(this.metrics.crossings_metric.value);
        return entry?.value?.toFixed(1) ?? 0;
    }

    showMetricsHistogram(title: string, metric: any) {
        this.selectedMetricTitle = title;
        this.$emit("metric-clicked", title, metric);
    }
}
